import { Dialog, DialogTitle, DialogContent, Box, Button, CircularProgress, IconButton, Divider } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { SnackbarActions } from '../redux/actions/snackbar.actions';
import { axiosFetch } from "../utils/AxiosFetch";
import InputAdornment from '@mui/material/InputAdornment';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { Close } from "@mui/icons-material";


function ChangePassword(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [oldPassword, setOldPassword] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [open, setOpen] = useState(props.open);
  const [showPwd, setShowPwd] = useState(false);
  const [showConfirmPwd, setShowConfirmPwd] = useState(false);
  const [showOldPaswd, setShowOldPswd] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  var isUserLogged = localStorage.getItem('argus_user') !== null ? JSON.parse(localStorage.getItem('argus_user')) : "";


  useEffect(() => {
    if (props.open) {
      setOpen(true)
      setPassword("");
      setConfirmPassword("");
      setOldPassword("")
    }
  }, [props.open])

  const handleChangePwd = () => {
    setLoading(true)
    var req = {
      "id": props.id,
      "password": password,
      "oldPassword": oldPassword,
    }

    axiosFetch({
      method: 'POST',
      url: `/Account/changepassword`,
      requestConfig: req,
    })
      .then((res) => {
        if (res.status === 200) {
          dispatch(SnackbarActions(true, "success", " Password changed successfully"))
          setOpen(false)
          props.handlePasswordPopup()
          setLoading(false)
        }
        if (res.status === 400) {
          setIsError(true);
          setErrMsg(res.data)
          setLoading(false)



        }
        if (res.status === 401) {
          navigate("/");
        }
      })
      .catch(error => {
        console.log(error);
      });
  }
  const handleClose = () => {
    setOpen(false)
    props.handlePasswordPopup()
  }

  ValidatorForm.addValidationRule("isPasswordMatch", (value) => {
    if (value !== password) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("haveLength", (value) => {
    if (value.length < 6) {
      return false;
    }
    return true;
  });
  ValidatorForm.addValidationRule("valid", (value) => {
    var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (value.match(paswd)) {
      return true;
    }
    return false;
  });
  ValidatorForm.addValidationRule('isEmpty', (value) => {
    if (value.trim().length === 0) {
      return false;
    }
    return true;
  });

  const handleOldPassword = (e) => {
    setIsError(false)
    setOldPassword(e.target.value)
  }

  const BootstrapDialogTitle = (props) => {
    const { children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {handleClose ? (
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <Close />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth="sm"
      maxWidth="sm"
    >
      <BootstrapDialogTitle className="modal-heading" id="alert-dialog-title">
        Change Password
      </BootstrapDialogTitle>
      <Divider />
      <DialogContent>
        <Box>
          <ValidatorForm
            // ref="form"
            data-testid="form"
            onError={(errors) => {
              console.log(errors.length);
            }}
            onSubmit={() => handleChangePwd()}
          >
            {isUserLogged.usertype !== "Admin" ?
              <>
                <TextValidator
                  variant="outlined"
                  className="signin-input-container"
                  label="Old Password"
                  onChange={handleOldPassword}
                  name="oldpassword"
                  type={showOldPaswd ? "text" : "password"}
                  value={oldPassword}
                  validators={["required", "isEmpty"]}
                  errorMessages={["Please fill out this field", "Invalid password"]}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment className='eye-icon' >
                        {showOldPaswd ? <VisibilityOffIcon onClick={() => setShowOldPswd(false)} />
                          : <VisibilityIcon onClick={() => setShowOldPswd(true)} />}
                      </InputAdornment>
                    )
                  }}
                />
                {isError ? <span style={{ color: "red" }}>{errMsg}</span> : ""}</> :
              <></>}
            <TextValidator
              variant="outlined"
              className="signin-input-container"
              label="New Password"
              onChange={(e) => setPassword(e.target.value)}
              name="password"
              type={showPwd ? "text" : "password"}
              value={password}
              validators={["required", "haveLength", "valid"]}
              errorMessages={["Please fill out this field", "Password must have atleast 6 Characters", "Password must have atleast one special char,one non-numeric and numeric value"]}
              InputProps={{
                endAdornment: (
                  <InputAdornment className='eye-icon' >
                    {showPwd ? <VisibilityOffIcon onClick={() => setShowPwd(false)} />
                      : <VisibilityIcon onClick={() => setShowPwd(true)} />}
                  </InputAdornment>
                )
              }}
            />
            <TextValidator
              variant="outlined"
              className="signin-input-container"
              label="Confirm Password"
              onChange={(e) => setConfirmPassword(e.target.value)}
              name="Confirmpassword"
              type={showConfirmPwd ? "text" : "password"}
              value={confirmPassword}
              validators={["required", "isPasswordMatch"]}
              errorMessages={[
                "Please fill out this field",
                "Password and Confirm Password should be same",
              ]}
              InputProps={{
                endAdornment: (
                  <InputAdornment className='eye-icon' >
                    {showConfirmPwd ? <VisibilityOffIcon onClick={() => setShowConfirmPwd(false)} />
                      : <VisibilityIcon onClick={() => setShowConfirmPwd(true)} />}
                  </InputAdornment>
                )
              }}
            />
            <div className="change-password">
              {loading ?
                <CircularProgress /> :
                <Button
                  data-testid="btn-login"
                  variant="contained"
                  type="submit"
                  className="theme-btn"
                >
                  Reset Password
                </Button>
              }
            </div>
          </ValidatorForm>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
export default ChangePassword;